import { Button } from '@mui/material'
import React from 'react'

interface PropsType {
  children: React.ReactNode;
  color: string;
  width?: string;
  onClick: () => void;
  type?: string;
  href?: string;
  disabled?: boolean;
}

function GradientButton({ children, color, onClick, width, type,  disabled = false }: PropsType): JSX.Element {

  const handleClick = (): void => {
    if(type !== "submit") {
      onClick()
    }
  }
  return (
    <>
      {
        color === "red" &&
        <React.Fragment>
          {
            type === "submit" ?
              <Button
                type='submit'
                sx={{
                  background: 'linear-gradient(to bottom, #ed4b52, #e84249, #e2393f, #dc2f36, #d6242c)',
                  borderRadius: '100px',
                  color: 'white',
                  padding: '0px 15px',
                  height: '35px',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'background 0.3s',
                  textTransform: 'none',
                  width: width !== undefined ? width : 'auto',
                  '&:hover': {
                    background: 'linear-gradient(to top, #ed4b52, #e84249, #e2393f, #dc2f36, #d6242c)',
                  },
                  '&.Mui-disabled': {
                    background: 'linear-gradient(to bottom, #ed4b52, #e84249, #e2393f, #dc2f36, #d6242c)',
                    opacity: 0.5 ,
                     color: 'white'
                  }
                }}
                onClick={handleClick}
                disabled={disabled}

              >
                {children}
              </Button> :
              <Button
                type='button'
                sx={{
                  background: 'linear-gradient(to bottom, #ed4b52, #e84249, #e2393f, #dc2f36, #d6242c)',
                  borderRadius: '100px',
                  color: 'white',
                  padding: '0px 15px',
                  margin:'0px 12px',
                  height: '35px',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'background 0.3s',
                  textTransform: 'none',
                  width: width !== undefined ? width : 'auto',
                  '&:hover': {
                    background: 'linear-gradient(to top, #ed4b52, #e84249, #e2393f, #dc2f36, #d6242c)',
                  },
                  '&.Mui-disabled': {
                    background: 'linear-gradient(to bottom, #ed4b52, #e84249, #e2393f, #dc2f36, #d6242c)',
                    opacity: 0.5 ,
                     color: 'white'
                  }
                }}
                onClick={handleClick}
                disabled={disabled}
              >
                {children}
              </Button>
          }

        </React.Fragment>
      }
    </>
  )
}

export default GradientButton